const RESIDENTIAL_ESTIMATE_NOTE_TEXT =
  "CSC estimated % complete is based on industry average and not the project specific schedule of values.";

interface ResidentialEstimateNoteProps {
  isCommercial?: boolean;
}

const ResidentialEstimateNote = ({
  isCommercial,
}: ResidentialEstimateNoteProps) => {
  if (isCommercial) return null;
  return (
    <div className="estNote">
      <div className="craNote">&quot;{RESIDENTIAL_ESTIMATE_NOTE_TEXT}&quot;</div>
    </div>
  );
};

export default ResidentialEstimateNote;
